import React, { FunctionComponent } from "react";
import { Alert } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../../helpers";

const BedapDownAlert: FunctionComponent<{ region: "plans" | "lis" }> = ({
  region,
}) => {
  const t = useTranslate();
  return (
    <Alert
      variation="warn"
      className="mct-c-summary-page-bedap-alert"
      aria-label={t(`summary_page.alert.bedap.label.${region}`)}
      data-testid="bedap-down-alert"
    >
      <h3 className="ds-u-margin--0 ds-text-heading--md">
        {t("summary_page.alert.bedap")}
      </h3>
      <p className="ds-u-margin--0">{t("summary_page.alert.bedap.cta")}</p>
    </Alert>
  );
};

export default BedapDownAlert;
